import React, { useEffect, useState } from 'react';
import { useSiteState } from '../../state/state';
import { Spacer } from '../common/Spacer';
import { SummaryBlock } from '../common/SummaryBlock';
import { ActionButton } from '../common/ActionButton';
import { Controller, useForm } from 'react-hook-form';
import { CheckinForm } from '../../service/checkin-flow';
import { Col, Form, Row } from 'react-bootstrap';
import { Activity } from '../../model/Model';

type ActivityStepProps = {
    buttonText: string,
    buttonLoadingText: string,
    buttonLoading: boolean,
    onStepComplete: (form: CheckinForm) => void,
    activities?: Activity[]
}

export const ActivityStep = ({ buttonText, buttonLoadingText, buttonLoading, onStepComplete, activities }: ActivityStepProps) => {
    const { settings } = useSiteState();
    const { control, handleSubmit, watch } = useForm<CheckinForm>();
    const selectedActivity = watch('activity');

    const [buttonDisabled, setButtonDisabled] = useState(true);

    useEffect(() => {
        if (selectedActivity && selectedActivity > 0) {
            setButtonDisabled(false);
        } else {
            setButtonDisabled(true);
        }
    }, [selectedActivity]);
    return (
        <>
            <form onSubmit={handleSubmit(onStepComplete)}>
                <Spacer height='2em' />
                <SummaryBlock display className='summary-block'>
                    <Row>
                        <Col className="px-0">
                            <Controller
                                name='activity'
                                control={control}
                                defaultValue={0}
                                render={({ onChange }) => (
                                    <Form.Group>
                                        <Form.Label className="med-heading">{settings?.siteActivitiesLabel ? settings?.siteActivitiesLabel : 'Activity'}</Form.Label>
                                        <Form.Control as="select" onChange={(e) => onChange(+e.target.value)}>
                                            <option key='opt_instr' value={0}>
                                                {settings?.siteActivitiesSelect ? settings?.siteActivitiesSelect : 'Please select activity'}
                                            </option>
                                            {activities ? activities.map(c => (
                                                <option key={`opt_${c.id}`} value={`${c.id}`}>
                                                    {c.name}
                                                </option>)) : null}
                                        </Form.Control>
                                    </Form.Group>
                                )}
                            />
                        </Col>
                    </Row>
                </SummaryBlock>
                <ActionButton text={buttonLoading ? buttonLoadingText : buttonText} disabled={buttonDisabled || buttonLoading} submit />
            </form>
        </>
    );
}
